import { render } from "./Store.vue?vue&type=template&id=7252b6ce"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Store.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7252b6ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7252b6ce', __exports__)) {
    api.reload('7252b6ce', __exports__)
  }
  
  module.hot.accept("./Store.vue?vue&type=template&id=7252b6ce", () => {
    api.rerender('7252b6ce', render)
  })

}


export default __exports__